<!--
 * @Author: shijianchen shijianchen@tujia.com
 * @Date: 2021-09-28 15:05:40
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @LastEditTime: 2022-12-22 18:52:59
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/linkmec/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div id="container">
    <div @click="showRule" class="ruleBtn">活动规则</div>
    <div class="banner">
      <img
        src="https://source.qunarzz.com/site/images/wns/20221215-shijianchen-banner.png"
        alt=""
      />
    </div>
    <div class="card">
      <div class="title">
        <img
          src="https://source.qunarzz.com/site/images/wns/20221215-shijianchen-title.png"
          alt=""
        />
      </div>
      <div class="tabs">
        <div @click="keepInfo" class="tab">
          <img
            src="https://source.qunarzz.com/site/images/wns/20221215-shijianchen-tab1.png"
            alt=""
          />
          <span class="tab-btn">{{
            setting.lz == '1' ? '已完成' : '去完成'
          }}</span>
        </div>
        <div class="tab">
          <img
            src="https://source.qunarzz.com/site/images/wns/20221215-shijianchen-tab2.png"
            alt=""
          />
          <gotomini @gotomini="addTimeBySource('xcx')"></gotomini>
          <span class="tab-btn tab-btn2 complete">{{
            setting.xcx == '1' ? '已完成' : '去完成'
          }}</span>
        </div>
      </div>
      <div class="des">
        -----------------(已完成 {{ voteCount }} 个任务)-----------------
      </div>
      <div v-if="!hasLottery" @click="lotteryFn" class="submit">立即抽奖</div>
      <div v-else @click="lookFn" class="submit">查看出行好礼</div>
    </div>
    <div class="card">
      <div class="title">
        <img
          src="https://source.qunarzz.com/site/images/wns/20221215-shijianchen-title2.png"
          alt=""
        />
      </div>
      <div class="cardList">
        <div class="bigCard">
          <img
            src="https://source.qunarzz.com/site/images/wns/20221215-shijianchen-card1.png"
            alt=""
          />
        </div>
        <div class="cardBoth">
          <img
            src="https://source.qunarzz.com/site/images/wns/20221215-shijianchen-card2.png"
            alt=""
          />
          <img
            src="https://source.qunarzz.com/site/images/wns/20221215-shijianchen-card3.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">
        <img
          src="https://source.qunarzz.com/site/images/wns/20221215-shijianchen-title3.png"
          alt=""
        />
      </div>
      <lineComp :lineList="lineList"></lineComp>
      <img
        src="https://source.qunarzz.com/site/images/wns/20221219-shijianchen-pen-1.png"
        class="qrcode"
        alt=""
      />
      <div class="title">
        <img
          src="https://source.qunarzz.com/site/images/wns/20221216-shijianchen-img.png"
          alt=""
        />
        <video-comp src="https://source.qunarzz.com/site/images/wns/20221216-shijianchen-video31.mp4" :poster="'https://source.qunarzz.com/site/images/wns/20221216-shijianchen-poster3.png'"></video-comp>
        <div @click="gohome" class="gotome">前往官网·查看更多</div>
      </div>
    </div>
  </div>
</template>
<script>
// import Home from './home.vue'
import loginDialog from '@/components/login/index';
import lineComp from './line.vue';
import keepDialog from './dialog/gift2/index';
import giftDialog from './dialog/gift/index';
import videoComp from './video.vue';
import gotomini from './gotomini.vue';
import ruleDialog from './dialog/ruleDialog/index'
export default {
  components: {
    lineComp,
    videoComp,
    gotomini,
  },
  data() {
    return {
      hasLottery: false,
      lineList: [
        [
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/520bdc2b-5028-473b-9914-6ec3dfe56294.jpg_r_640x420x95_fccd5eaa.jpg',
            tagList: ['雪山温泉', '草原'],
            price: 4300,
            tag: '服务贴心/早餐很赞',
            desc: '松下新风冰雪线路推荐|崇礼滑雪开板~张家口云顶大酒店2晚房型多选含早餐|赠送双人2日云顶滑雪场滑雪票·体验专业奥运赛道国际水准·豪华住宿体验',
            descList: [
              '【精选酒店】云顶大酒店主楼+北翼楼多房型可选',
              '【贴心赠送】张家口崇礼云顶国际滑雪场双人雪票',
            ],
            linkId: 'https://touch.dujia.qunar.com/p/item/495440363',
            discountId: '1678403036',
          },
          {
            headImg:
              'https://img1.qunarzz.com/vs_ceph_b2c_001/6b274157-b436-4136-bf85-2f4491f6fbde.jpg_r_640x420x95_84827d39.jpg',

            tagList: ['海鲜自助', '海岛游'],
            price: 4160,
            desc: '松下新风冰雪线路推荐|哈尔滨+亚布力+雪乡+漠河+北极村7日|北极圣诞村滑雪+雪国列车开往童话世界+北红村雪乡',
            descList: [
              '【缤纷景点】【圣诞老人之冬】 唯美雪乡童话世界',
              '【贴心赠送】探寻“差点被遗忘”的中国北极，邂逅北极光',
            ],
            tag: '环境舒适/客房干净',
            linkId: 'https://touch.dujia.qunar.com/p/item/1753693476',
            discountId: '3770793980',
          },
          {
            headImg:
              'https://source.qunarzz.com/site/images/wns/20221130-shijianchen-linke-t3.png',

            tagList: ['海鲜自助', '海岛游'],
            price: 7510,
            desc: '松下新风冰雪线路推荐|长白山5日私家团|粉雪万达滑雪初体验+皇冠假日+万达锦华+北坡VIP通道免排队+双温泉+峡谷漂流',
            descList: [
              '【优质交通】私家一单一团，金牌司兼导服务',
              '【精选酒店】品牌酒店:皇冠假日+锦华度假',
              '【缤纷景点】日登天池夜泡双坡温泉，峡谷漂流 萌宠乐园',
            ],
            tag: '房间干净/环境舒适',
            linkId: 'https://touch.dujia.qunar.com/p/item/4230723222',
            discountId: '3770793980',
          },
        ],
      ],
      videoList:[
        {
          src:'https://source.qunarzz.com/site/images/wns/20221216-shijianchen-video11.mp4',
          poster:'https://source.qunarzz.com/site/images/wns/20221216-shijianchen-poster1.png'
        },
        {
          src:'https://source.qunarzz.com/site/images/wns/20221216-shijianchen-video21.mp4',
          poster:'https://source.qunarzz.com/site/images/wns/20221216-shijianchen-poster2.png'
        },
        {
          src:'https://source.qunarzz.com/site/images/wns/20221216-shijianchen-video31.mp4',
          poster:'https://source.qunarzz.com/site/images/wns/20221216-shijianchen-poster3.png'
        }
      ],
      voteCount: 0,
      setting: {
        lz: 0,
        xcx: 0,
      },
    };
  },
  mounted() {
    // loginDialog({});
    this.getChannelNum();
  },
  methods: {
    showRule:ruleDialog,
    gohome(){
      location.href = "https://iaq.panasonic.cn/"
    },
    submit(params,done) {
      this.$http({
        url: '/keepInfo/keepInfoPanasonic',
        type: 'post',
        data:{
          name: params.userName,
          phone: params.userPhone,
          province:params.province,
          city:params.city
        },
        success: (res) => {
          if (res.code == 200) {
            this.$dialog.alert({
              message: '提交成功',
            });
            done && done();
            this.addTimeBySource('lz');
          } else {
            this.$dialog.alert({
              message: res.message,
            });
          }
        },
      });
    },
    getMyPrize() {
      this.$http({
        url: '/commonly/getMyPrzie',
        type: 'get',
        success: (res) => {
          let result = [];
          res.data.forEach((item) => {
            result.push(item);
          });
          this.hasLottery = result.length > 0;
        },
      });
    },
    lotteryFn() {
      this.$http({
        url: '/commonly/v2/lottery',
        type: 'post',
        success: (res) => {
          giftDialog({
            type: res.data.code,
            callback: (params, done) => {
              this.getChannelNum();
            },
          });
          this.getChannelNum();
        },
      });
    },
    lookFn() {
      location.href =
        'https://touch.dujia.qunar.com/pg/pv/event/sx8z?et=ip_yh_sx';
    },
    addTimeBySource(source) {
      this.$http({
        url: '/commonly/addTimeBySource?source=' + source,
        type: 'get',
        login: loginDialog,
        error: () => {},
        success: (res) => {
          // this.voteCount = res.data.voteCount;
          this.getChannelNum();
        },
      });
    },
    keepInfo() {
      keepDialog({
        callback: (params,done) => {
          this.submit(params,done);
        },
      });
    },
    getChannelNum() {
      this.$http({
        url: '/commonly/getChannelNum',
        type: 'get',
        error: () => {},
        success: (res) => {
          this.setting = res.data;
          this.voteCount = res.data.zs;
          this.getMyPrize();
        },
      });
    },
  },
};
</script>
<style lang='less' scoped='true'>
#container {
  background-color: #f0f7fe;
  min-height: 100vh;
}
.ruleBtn {
  position: absolute;
  right: 10px;
  top: 15px;
  width: 66px;
  height: 23px;
  background: rgba(61, 61, 61, .54);
  border-radius: 12px;
  font-size: 12px;
  color: #fff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tabs {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  .tab {
    position: relative;
    height: 127px;
    width: 168px;
  }
  img {
    width: 168px;
    height: 127px;
    position: absolute;
    left: 0;
    top: 0;
  }
  .tab-btn {
    position: absolute;
    left: 12px;
    bottom: 15px;
    width: 70px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ecca98;
    background: #bc8d49;
    border-radius: 13px;
    &2 {
      background-color: #4bb9c2;
      color: #fff;
    }
  }
}
.des {
  opacity: 0.6;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #0056a7;
  letter-spacing: 0;
  line-height: 17px;
  font-weight: 400;
  margin-top: 8px;
  margin-bottom: 8px;
}
.qrcode {
  margin-left: 16px;
  margin-right: 16px;
  width: calc(100% - 32px);
}
.submit {
  background-image: linear-gradient(154deg, #2ab9f9 0%, #059aed 100%);
  border-radius: 12px;
  margin-left: auto;
  margin-right: auto;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  // opacity: 0.5;
  font-size: 18px;
}
.card {
  background-image: linear-gradient(179deg, #e8f4ff 0%, #ffffff 24%);
  border: 1px solid rgba(255, 255, 255, 1);
  width: calc(100% - 32px);
  margin-left: auto;
  padding-top: 20px;
  margin-right: auto;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 15px;
  border-radius: 20px;
}
.cardBoth {
  display: flex;
  justify-content: space-between;
  margin-top: 7px;
  img {
    width: 168px;
    height: 67px;
  }
}
.gotome {
  width: 355px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.5px solid rgba(0, 86, 167, 1);
  border-radius: 18px;
  margin: 0 auto;
  font-size: 13px;
  color: #0056a7;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 26px;
  margin-bottom: 70px;
}
.swipe-wrapper{
  height: 200px;
  width:355px;
  margin:0 auto;
}
</style>